import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const StyledDomainCard = styled.div`
    background: ${props => props.background};
    width: 340px;
    height: 125px;
    position: relative;
    overflow: hidden;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0,0,0, 0.15);
    display: grid;
    grid-template-rows: 1fr 1fr;
    transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    cursor: pointer;
    

    :hover {
        transform: scale(1.1, 1.1);
        box-shadow: 0 30px 60px rgba(0,0,0, 0.5);
    }

    
    h3 {
        color: #6c757d;
        font-size: 1rem;
        margin: 20px 0 0 20px;
        width: 270px;
    }
    
    p {
        color: #6c757d;
        text-transform: uppercase;
        font-weight: 600;
        font-size: .5rem;
        align-self: end;
        margin: 0 0 20px 20px;
    }

    /*desktop version*/
    @media (min-width: 900px) {
        height: 225px;
        h3 {
            font-size: 30px;
        }
        p {
            font-size: .7rem;
        }
    }
`

const DomainCard = ({ title, text, background, link }) => {
    return (
        <>
            <Link to={link}>
                <StyledDomainCard background={background}>
                    <h3>{title}</h3>
                    <p>{text}</p>
                </StyledDomainCard>
            </Link>
        </>
    )
}
export default DomainCard;
